import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { createFocusManager } from './createFocusManager';
var FocusManagerContext = createContext(null);
export var FocusManagerScope = function (props) {
    var scopeRef = props.scopeRef, autoFocus = props.autoFocus, children = props.children;
    var manager = useMemo(function () { return createFocusManager(scopeRef); }, [scopeRef]);
    useEffect(function () {
        if (autoFocus) {
            manager.focusFirst();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return React.createElement(FocusManagerContext.Provider, { value: manager }, children);
};
export function useFocusManager() {
    var manager = useContext(FocusManagerContext);
    if (!manager) {
        throw new Error('Could not find focus manager context value. Please ensure the component is wrapped in a <FocusManagerScope />');
    }
    return manager;
}
